export const rootURL = '/api';
export const baseURL = rootURL + '/api';

export const InvoicePreviewAssets = '<minvoice id="template-preview">' +
  '<link type="text/css" rel="stylesheet" href="/assets/invoice/css/template-preview.css" />' +
  '<script src="/assets/invoice/javascript/jquery-3.6.0.min.js"></script>' +
  '<script src="/assets/invoice/javascript/template-preview.js"></script>' +
  '</minvoice>';
